module.exports = __webpack_public_path__ + "static/img/3-3.dd082bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/3-3.png
// module id = oRZx
// module chunks = 0